import { getEnv } from '@schooly/utils/runtime-env';

export const AUTH_APP_BASE_PATH = '/auth';
export const SERVER = getEnv('VITE_SERVER') ?? '';
export const WEB_APP_URL = import.meta.env.VITE_OVERRIDE_WEB_APP_URL || window.location.origin;
export const LOGIN_EXISTING_ACCOUNT_PATH = `${AUTH_APP_BASE_PATH}/login-existing-account`;

export const DEBUG = import.meta.env.VITE_DEBUG;
export const IS_DEV = import.meta.env.DEV;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENVIRONMENT_NAME = import.meta.env.VITE_ENVIRONMENT_NAME;
export const SENTRY_TRACES_SAMPLE_RATE = Number(
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.02,
);
export const SENTRY_PROFILES_SAMPLE_RATE = Number(
  import.meta.env.VITE_SENTRY_PROFILES_SAMPLE_RATE ?? 0.02,
);

const cookieDomain = getEnv('VITE_ORIGIN');
const isLocalhost = cookieDomain === 'localhost';
const cookieSameSite = isLocalhost || IS_DEV ? 'lax' : 'none';
const cookieSecure = !isLocalhost && !IS_DEV;

// Capitalized keys are expected for amplify config
export const AWS_CONFIG = {
  Auth: {
    mandatorySignIn: true,
    region: import.meta.env.VITE_AWS_REGION,
    userPoolId: import.meta.env.VITE_COGNITO_IDENTITY_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_COGNITO_IDENTITY_USER_POOL_CLIENT_ID,
    identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL,
    cookieStorage: {
      domain: cookieDomain,
      sameSite: cookieSameSite,
      secure: cookieSecure,
    },
    // identityPoolRegion: import.meta.env.VITE_AWS_REGION,
  },
  Storage: {
    bucket: import.meta.env.VITE_PUBLIC_UPLOADS_S3_BUCKET,
    region: import.meta.env.VITE_AWS_REGION,
  },
};

export const {
  VITE_DATE: BUILD_DATE,
  VITE_COMMIT_SHA: COMMIT_SHA,
  VITE_LANGUAGE: LANGUAGE,
} = import.meta.env;

export const AMPLITUDE_API_KEY = '1f2097cac9ef4f06779cc7791890532c';

IS_DEV &&
  /** biome-ignore lint/suspicious/noConsole: debug logging */
  console.info({
    AWS_CONFIG,
    SERVER,
    WEB_APP_URL,
    DEBUG,
    IS_DEV,
    BUILD_DATE,
    COMMIT_SHA,
    LANGUAGE,
  });
